import IframeActivity from "./IframeActivity";

export default function BeforeTheyKnew() {
    return (
        <IframeActivity
            src="/activities/before-they-knew/index.html"
            title="Before They Knew It"
        />
    );
}